import { graphDataOrEmptyObjectSelector } from '../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY, BASE_EXPENSE } from './ExpensesWorkflowConstants';

interface TotalExpenses {
  Amount: number | null;
}

export const selectTotalExpenses = (state, props): TotalExpenses => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  return graphDataOrEmptyObjectSelector(state, props)[BACKEND_KEY] || BASE_EXPENSE;
};

export const selectTotalExpensesAmount = (state, props) => selectTotalExpenses(state, props).Amount;
